export const SEND_CONTACT_REQUEST = 'SEND_CONTACT_REQUEST';
export const SEND_CONTACT_SUCCESS = 'SEND_CONTACT_SUCCESS';
export const SEND_CONTACT_FAILURE = 'SEND_CONTACT_FAILURE';

export const sendContactRequest = (data) => ({
  type: SEND_CONTACT_REQUEST,
  payload: data,
});

export const sendContactSucces = (message) => ({
  type: SEND_CONTACT_SUCCESS,
  payload: message,
});

export const sendContactFailure = (error) => ({
  type: SEND_CONTACT_FAILURE,
  payload: error,
});
